import React from 'react'
import { Link } from 'react-router-dom'
import logoImage from './../../images/logo.png'
import { NamedRoutes } from '../../routes'
import { useStyles } from './Styles'

const Logo = ({ noLink }) => {
  const classes = useStyles()
  return (
    <div className={classes.logo}>
      {!!noLink ? <img alt='logo' src={logoImage}/> :
        <Link to={NamedRoutes.home}> <img alt='logo' src={logoImage}/> </Link>
      }
    </div>)
}

export default Logo
